module.exports = __webpack_public_path__ + "img/單一商品介紹背景.42664c0b.svg";